import serviceProvider from '../../../services/provider/ProviderService.js'
import BranchList from './branchList.vue'
import i18n from "../../../i18n/index";
import branchService from '../../../services/branch/BranchService.js'
import unifiedPharmacyService from '../../../services/unified-pharmacy/UnifiedPharmacyService'
import { StorageService } from '../../../services/StorageService';
import locationService from '../../../services/location/LocationService.js'


export default {
    data: () => ({
        hideList: false,
        rules: { required: value => !!value || i18n.t('field-required') },
        integratedProvider: 0,
        branch: {
            id: '',
            name: '',
            idProvider: '',
            type: 'EXCLUSIVE',
            active: '',
            idUnifiedPharmacy: 0
            // idDeliveryPoint: {
            //     id: '',
            //     name: '',
            //     address: ''
            // },
            // isDeliveryPoint: false,
            // address: '',
            // idCity: ''
        },
        cities: [],
        location: {
            state: '',
            city: ''
        },
        states: '',
        cities: '',
        providers: [],
        loadingDelete: false,
        showDelete: false,
        chkBranch: false,
        showUpdate: false,
        showAdd: true,
        unifiedPharmacies: [{ id: 0, name: 'NO' }],
        disableprovider:false,
    }),
    components: {
        BranchList
    },
    mounted() {
        this.integratedProvider = StorageService.getIntegratedProvider();
    },
    created() {
        // this.getStates()
    },
    methods: {
        async showCreateBranch() {
            await this.getProviders();
            // await this.getUnifiedPharmacies()
            this.hideList = true
            this.showUpdate = false;
            this.showAdd = true;
        },
        async update(item) {
            console.log(item)
            await this.showCreateBranch()
            //this.branch.idUnifiedPharmacy = item.idUnifiedPharmacy ? item.idUnifiedPharmacy.id : 0
            this.branch.idUnifiedPharmacy =  0;
            this.branch.idProvider = item.idProvider.id
            this.branch.name = item.name
            this.branch.type = 'EXCLUSIVE';
            this.chkBranch = item.active;
            this.branch.id = item.id
            this.loadingDelete = false;
            this.showDelete = true;
            this.showUpdate = true;
            this.showAdd = false;

            // this.branch.isDeliveryPoint = item.idDeliveryPoint ? true : false;
            // if (item.idDeliveryPoint) {
            //     this.branch.address = item.idDeliveryPoint.address
            //     this.branch.idDeliveryPoint = {
            //         id: item.idDeliveryPoint.id,
            //         name: this.branch.name,
            //         address: this.branch.address
            //     }
            //     this.branch.idCity = this.location.city;
            // }
            // console.log(' item', this.branch.isDeliveryPoint = item.idDeliveryPoint != null);
            // console.log('update item', this.branch);
        },
        createBranch() {
            if (!this.$refs.branchForm.validate()) {
                this.$notify({
                    group: "app",
                    type: "error",
                    text: i18n.t("app.error-required-fields")
                });
                return;
            }
            this.branch.type = 'EXCLUSIVE';
            this.branch.idUnifiedPharmacy = 0;
            // this.branch.idDeliveryPoint = {
            //     name: this.branch.name,
            //     address: this.branch.address
            // }
            // this.branch.idCity = this.location.city;
             console.log(this.branch)
            branchService.createBranch(this.branch).then(res => {
                this.$refs.BranchList.getBranches();
                this.$notify({
                    group: "app",
                    type: "success",
                    text: i18n.t('record-successfully-created')
                });
                this.hideList = false;
            }).catch(error => {
                if (error && error.code) {
                    const errorCode = error.code;

                    if (errorCode === 'COVERAGE_OVERLAY') {
                        this.$notify({
                            group: 'app',
                            type: 'error',
                            text: i18n.t('branches.error-coverage-overlay')
                        });
                    }
                }
            });
        },
        async getStates() {
            await locationService.getStatesByCountry().then(response => {
                this.states = response.data;
                this.location.state = '';
                this.location.city = '';
            });
        },
        getCities() {
            locationService.getCitiesByState(this.location.state).then(response => {
                this.cities = response.data;
                this.location.city = '';
            });
        },
        async getProviders() {
            this.branch = {
                id: '',
                name: '',
                idProvider: '',
                type: '',
                idUnifiedPharmacy: '',
                address: ''
            }
            const userInfo = JSON.parse(localStorage.getItem('user'))
            await serviceProvider.getProviders().then(response => {
                this.providers = response.data;
                if(userInfo.providerId){
                  this.branch.idProvider = userInfo.providerId;
                  this.disableprovider = true;
                }
            });
        },
        async getUnifiedPharmacies() {
            await unifiedPharmacyService.get().then(response => {
                this.unifiedPharmacies = this.unifiedPharmacies.concat(response.data)
            });
        },
        deleteBranch() {
            let data = { id: this.branch.id };
            this.loadingDelete = true;
            branchService.deleteBranch(data).then(result => {
                if (result.status == 200 || result.status == 201) {
                    this.loadingDelete = false;
                    this.$notify({
                        group: "app",
                        type: "success",
                        text: 'Sede Eliminada exitosamente'
                    });
                    this.$refs.BranchList.getBranches();
                    this.hideList = false;
                    // this.closeUser();
                }
            }).catch(error => {
                this.loadingDelete = false;
                this.showIcon = false;
                if (error && error.code) {
                    if (error.code == 'The Branch has associated transactions') {
                        this.$notify({
                            group: "app",
                            type: "error",
                            text: "La sede tiene transacciones no se puede eliminar"
                        })
                    }
                }
                // this.$refs.municipioList.searchCity();
                // this.closeUser();
            });
        },
        updateBranch() {

            // if (this.branch.isDeliveryPoint) {
            //     if (this.branch.address === '') {
            //         this.$notify({
            //             group: "app",
            //             type: "error",
            //             text: "Debe ingresar una dirección"
            //         })
            //         return
            //     }
            // }

            let branchId = this.branch.id;
            this.branch.active = this.chkBranch;
            // let dpBody
            // if (this.branch.isDeliveryPoint) {
            //     if (this.branch.idDeliveryPoint) {
            //         dpBody = {
            //             id: this.branch.idDeliveryPoint.id,
            //             name: this.branch.name,
            //             address: this.branch.address
            //         }
            //     } else {
            //         dpBody = {
            //             id: undefined,
            //             name: this.branch.name,
            //             address: this.branch.address
            //         }
            //     }
            // }
            let data = {
                name: this.branch.name,
                idProvider: this.branch.idProvider,
                type: 'EXCLUSIVE',
                active: this.branch.active == true ? true : false,
                idUnifiedPharmacy: 0
                // address: this.branch.address,
                // isDeliveryPoint: this.branch.isDeliveryPoint,
                // idDeliveryPoint: dpBody ? dpBody : undefined,
                // idCity: this.location.city
            };

            this.loadingSaveButton = true;
            this.showIcon = true;

            branchService.updateBranch(branchId, data).then(result => {
                this.loadingSaveButton = false;
                if (result.status == 200 || result.status == 201) {
                    this.$notify({
                        group: "app",
                        type: "success",
                        text: "Sede Actualizada"
                    });
                    this.$refs.BranchList.getBranches();
                    this.hideList = false;
                }
            }).catch(error => {
                this.loadingSaveButton = false;
                this.showIcon = false;
                if (error && error.code) {
                    if (error) {
                        this.$notify({
                            group: "app",
                            type: "error",
                            text: "La Sede tiene transacciones"
                        })
                    }
                }
                this.$refs.BranchList.getBranches();
                this.hideList = false;
            });
        }
    }
}